import { axiosInstance } from '@/modules/shared/lib/axios'
import { DeleteCompanyGroupsRequest } from './types'

type Props = {
  companyId: string
  payload: DeleteCompanyGroupsRequest
}

export function deleteCompanyGroups({ companyId, payload }: Props) {
  return axiosInstance.post(
    `/config-api/${companyId}/configuration/admin/companies/removeCompanyGroups`,
    payload
  )
}
